import {setGlobalValue} from '../../redux-actions/global-actions.js'
import store from '../../init/store.js'
import {getDeadTeams} from '../lifecycle/get-dead-teams.js'
import {setMatchmakingValue} from '../../redux-actions/battle-actions.js'

export function handleBattleOver() {

  //Did I win or lose?
  const myTeamId = store.getState().battle.combatants[ store.getState().battle.battlePlayerId[0] ].belongsToTeam;
  const didILose = getDeadTeams().includes(myTeamId);

  //Mark this result in state. The BattleOverScreen / BattleResults will use this to interact with Firebase
  setMatchmakingValue({
    matchResult: didILose ? "lose" : "win"
  });


  //Transition to the Battle Over screen for either Multiplayer or Offline Quick battle mode
  const nextGameArea = store.getState().battle.isMultiplayerMode
    ? "b5-online-battle-over"
    : "b5-offline-battle-over";

  setGlobalValue({
    gameArea: nextGameArea
  })
}


// WEBPACK FOOTER //
// ./src/battle/ArenaView/handleBattleOver.js